import Vue from 'vue'
import utils from './utils'
import store from '../store/index'
export default {
  dialogs: [{ value: false, name: 'login' }, { value: false, name: 'register' }, { value: false, name: 'support' }, { value: false, name: 'welcome' }],

  todayDate () {
    // var minDate = ''
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = yyyy + '-' + mm + '-' + dd
    return today
    // this.minDate = today
    // console.log('min date', this.minDate)
  },

  preventNonNumericalInput (e) {
    e = e || window.$event
    var charCode = (typeof e.which === 'undefined') ? e.keyCode : e.which
    var charStr = String.fromCharCode(charCode)

    if (!charStr.match(/^[0-9]|[٠-٩]$/)) {
      e.preventDefault()
    }
  },

  checkLang () {
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'ar')
      this.$lang = 'ar'
    } else {
      Vue.prototype.$lang = localStorage.getItem('lang')
    }
  },
  // checkLang () {
  //   // Always ensure lang is set, default to 'ar'
  //   const lang = localStorage.getItem('lang') || 'ar'
  //   localStorage.setItem('lang', lang)
  //   this.$lang = lang
  //   return lang
  // },

  changeLang (i) {
    if (i === 0) {
      localStorage.setItem('lang', 'ar')
    } else {
      localStorage.setItem('lang', 'en')
    }
    location.reload()
  },

  changeDialogStatus (index) {
    if (index === 3) {
      store.state.rotate = !store.state.rotate
    }
    utils.dialogs[index].value = !utils.dialogs[index].value
  },

  checkActiveTab (items, active) {
    return items.findIndex(o => o.path === active)
  },

  checkActiveTabViaId (items, active) {
    // for (let i = 0; i < items.length; i++) {
    //   if (items[i].id === active) {
    //     console.log('hhihihihih', items[i])
    //     // return i
    //   }
    // }
    return items.findIndex(o => o.id === active)
  },
  async forward (instance, val, size, visited, shouldBeDragged) {
    const page = Math.floor((val - 1) / size) + 1
    if (!visited.includes(page) && page < shouldBeDragged - 1 && val % size === 0) {
      try {
        const response = await instance.getPage(page, size)
        if (response.status === 200) {
          let temp = []
          temp = [...response.data.data]
          visited.push(page)
          return { arr: temp, type: 0 }
        }
      } catch (e) {
        return e
      }
    } else if (!visited.includes(page) && page === shouldBeDragged - 1 && val % size === 0) {
      try {
        const response = await this.instance.getPage(page, size)
        if (response.status === 200) {
          let temp = []
          temp = [...response.data.data]
          visited.push(page)
          return { arr: temp, type: 1 }
        }
      } catch (e) {
        return e
      }
    }
  },
  async backward (instance, val, size, visited, shouldBeDragged) {
    const page = Math.floor((val - 1) / size) - 1
    if (!visited.includes(page) && page === shouldBeDragged - 1 && page >= 0) {
      try {
        const response = await instance.getPage(page, size)
        if (response.status === 200) {
          let temp = []
          temp = [...response.data.data]
          visited.push(page)
          return temp
        }
      } catch (e) {
        return e
      }
    } else if (!visited.includes(page) && page < shouldBeDragged - 1 && page >= 0) {
      try {
        const response = await instance.getPage(page, size)
        if (response.status === 200) {
          let temp = []
          temp = [...response.data.data]
          visited.push(page)
          return temp
        }
      } catch (e) {
        return e
      }
    }
  }
}
